export default __webpack_public_path__ + "static/media/gestao-recursos-centralizada.0bee3fef.svg";